import color from 'color';

const PRIMARY = '#3DB0FB';
const GRAY = '#868D9B';
const FORM_FONT_SIZE = 20;

const SIBLING_SPACING = 12;
const HEADER_PADDING = SIBLING_SPACING;
const HEADER_INTERNAL_HEIGHT = 30;
const HEADER_HEIGHT = HEADER_INTERNAL_HEIGHT + HEADER_PADDING * 2;

const theme = {
  primary: PRIMARY,
  lighterPrimary: color(PRIMARY)
    .lighten(0.5)
    .string(),
  background: '#FFFFFF',
  text: '#000000',
  subText: '#44454A',
  buttonText: '#FFFFFF',
  border: '#D4D6DD',
  disabled: '#D4D6DD',
  shadow: `${color(GRAY)
    .lighten(0.3)
    .string()} 0 1px 2px`,
  error: 'red',
  danger: '#F5507E',
  placeholder: '#BABABA',
  outline: '#00AEEF 4px',
  backgroundHighlighted: '#CCEAFF',
  borderHighlightedColor: '#00AEEF',
  shadowHighlightedColor: '#D4D6DD',

  // colors
  gold: '#DAA520',
  darkGray: GRAY,
  buttonColor: '#00AEEF',
  lighterButtonColor: '#CCEAFF',
  lightestGray: '#FAFAFA',
  lighterGray: '#F3F5F9',
  transGray: '#868d9b1a',

  // Layout
  header: '65px',
  content: `calc(100% - 40px  - 135px)`,
  footer: '100px',

  // Typography
  baseFontFamily: 'Roboto',
  formFontSize: `${FORM_FONT_SIZE}px`,
  formLineHeight: `${1.2 * FORM_FONT_SIZE}px`,
  inputHeight: '62px',

  // breakpoints
  breakpoints: {
    xs: 300,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },

  // spacing
  superViewSpacing: 24,
  siblingSpacing: SIBLING_SPACING,
  headerPadding: HEADER_PADDING,
  headerInternalHeight: HEADER_INTERNAL_HEIGHT,
  headerHeight: HEADER_HEIGHT,
  largeFontSize: 20,
};

export default theme;
